module.exports = __webpack_public_path__ + "img/logo_xingou.d92403bf.png";